var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.247 63.1751C60.7335 63.1751 71.6665 52.2421 71.6665 38.7556C71.6665 25.2691 60.7335 14.3361 47.247 14.3361C33.7605 14.3361 22.8275 25.2691 22.8275 38.7556C22.8275 52.2421 33.7605 63.1751 47.247 63.1751Z",
    fill: "#4AD3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0375 47.1495C39.6161 47.1495 47.1869 47.0979 55.896 42.0696C64.6052 37.0415 67.4234 30.7425 68.3252 27.5177C68.4063 27.2262 68.4282 26.9214 68.3901 26.6214C68.3519 26.3212 68.2544 26.0317 68.1032 25.7696C67.9519 25.5077 67.75 25.2785 67.509 25.0953C67.2682 24.9122 66.9933 24.7789 66.7004 24.7032C64.588 24.1619 60.94 23.6724 56.2469 24.7857",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8274 24.7855C9.13458 23.6725 5.48686 24.1619 3.37454 24.7033C3.08161 24.779 2.80669 24.9122 2.56584 25.0954C2.32499 25.2785 2.12302 25.5077 1.97175 25.7696C1.82048 26.0317 1.72293 26.3212 1.68479 26.6214C1.64666 26.9215 1.6687 27.2263 1.74964 27.5178C2.65146 30.7425 5.46973 37.0415 14.1789 42.0696C22.8881 47.0979 30.4587 47.1495 35.0374 47.1495",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0375 47.1495C35.0375 47.1495 46.4841 40.9059 46.4841 24.2562C46.4841 11.2116 39.4577 4.55452 36.4149 2.28332C36.0173 1.98572 35.5341 1.82489 35.0375 1.82489C34.5408 1.82489 34.0576 1.98572 33.66 2.28332C30.6172 4.55452 23.5908 11.2116 23.5908 24.2562C23.5908 40.9059 35.0375 47.1495 35.0375 47.1495Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0375 47.1497C38.4687 46.42 47.7233 41.2026 53.27 31.5955C58.8166 21.9883 57.4505 14.3171 56.3668 10.9806C56.1925 10.4423 55.8247 9.98764 55.3347 9.70468C54.8446 9.42172 54.2669 9.3306 53.7135 9.44873C50.4326 10.1926 47.364 11.6737 44.7404 13.7798",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3343 13.7797C22.7109 11.6737 19.6423 10.1926 16.3614 9.44873C15.808 9.3306 15.2304 9.42172 14.7402 9.70468C14.2502 9.98764 13.8825 10.4423 13.708 10.9806C12.6245 14.3171 11.2583 21.9883 16.805 31.5955C22.3518 41.2026 31.6063 46.42 35.0374 47.1497",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.0774cc3095ff19177d3b68765d7136e6.svg";
export { ForwardRef as ReactComponent };